import React, { Component } from 'react';
import { GECKO_CONSTS, GeckoField } from 'ui';
import AsyncSelect from 'components/AsyncSelect';
import AnswerSelectRow from 'components/AnswerSelectRow';
import { connect } from 'react-redux';

import './index.scss';

class AnswerSelect extends Component {
  changeHandler(key, val) {
    this.props.onChange(val);
  }

  renderOption(option) {
    // renders custom row design and performs fetch to get answer/skill data
    return <AnswerSelectRow answer={option} />;
  }

  render() {
    const selectField = {
      label: 'Choose an Answer',
      key: 'response_id',
      type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
      component: (
        <AsyncSelect
          selectUrl={`/bots/${this.props.botId}/answers/select`}
          getUrl={`/bots/${this.props.botId}/answers`}
          optionTransform={(answer) => {
            const answerContents = answer.answers.reduce((contents, answer) => {
              return `${contents} ${answer.content}`;
            }, '');
            return {
              name: answer.name,
              value: answer.id,
              type: answer.type,
              answers: answer.answers,
              bot_tags: answer.bot_tag_ids.map(
                (tag) => this.props.tagsById[tag].name
              ),
              skill_name: answer.skill_name,
              label: `${answer.name} ${answer.skill_name} ${answerContents}`,
            };
          }}
          field={{
            config: {
              valueRenderer: this.renderOption.bind(this),
              optionRenderer: this.renderOption.bind(this),
              filterOption: (option, filterString) => {
                const isContainedIn = (str1, str2) => {
                  if (!str1) {
                    return true;
                  }
                  if (!str2) {
                    return false;
                  }
                  return str2.toLowerCase().includes(str1.toLowerCase());
                };
                const containsFilterString = isContainedIn.bind(
                  null,
                  filterString
                );
                if (containsFilterString(option.name)) {
                  return true;
                }
                if (containsFilterString(option.skill_name)) {
                  return true;
                }
                if (
                  option.answers
                    .map((answer) => answer.content)
                    .some(containsFilterString)
                ) {
                  return true;
                }
                if (option.bot_tags.some(containsFilterString)) {
                  return true;
                }
                return false;
              },
            },
          }}
        />
      ),
    };
    return (
      <div>
        <GeckoField
          field={selectField}
          values={{ response_id: this.props.value }}
          handler={this.changeHandler.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagsById: state.bot_tags.byId,
  };
};

export default connect(mapStateToProps)(AnswerSelect);
